// extracted by mini-css-extract-plugin
export default {"control":"control_control__oGHV7","addIcon":"control_addIcon__A48L3"};